import {
  Directive,
  Input,
  ElementRef,
  AfterViewInit,
  inject,
} from '@angular/core';

@Directive({
  selector: '[appAnimateProgressBar]',
  standalone: false,
})
export class AnimateProgressBarDirective implements AfterViewInit {
  private readonly el = inject(ElementRef<HTMLElement>);

  @Input() progressValue: number = 0;
  @Input() animationDelay: number = 0;

  ngAfterViewInit(): void {
    this.animateBar();
  }

  private animateBar(): void {
    const element = this.el.nativeElement;

    // Set initial state
    element.style.width = '0%';
    element.style.opacity = '0';

    element.animate(
      [
        { width: '0%', opacity: 0 },
        { width: `${this.progressValue}%`, opacity: 1 },
      ],
      {
        duration: 1200,
        delay: this.animationDelay,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: 'forwards',
      }
    );
  }
}
